var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#B3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21728 12.2H14.5827L15.1149 15.2826C15.193 15.7347 15.3573 16.1675 15.599 16.5575C15.6285 16.6052 15.5943 16.6667 15.5383 16.6667H8.22634C8.18645 16.6667 8.16255 16.6223 8.18449 16.589C8.4545 16.179 8.63543 15.7168 8.71557 15.2324L9.21728 12.2Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.06665 13.5333C8.06665 12.9442 8.54421 12.4667 9.13332 12.4667H14.8C15.3891 12.4667 15.8667 12.9442 15.8667 13.5333C15.8667 14.1224 15.3891 14.6 14.8 14.6H9.13332C8.54421 14.6 8.06665 14.1224 8.06665 13.5333Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8 12.6667H9.13332C8.65467 12.6667 8.26665 13.0547 8.26665 13.5333C8.26665 14.012 8.65467 14.4 9.13332 14.4H14.8C15.2786 14.4 15.6666 14.012 15.6666 13.5333C15.6666 13.0547 15.2786 12.6667 14.8 12.6667ZM9.13332 12.4667C8.54421 12.4667 8.06665 12.9442 8.06665 13.5333C8.06665 14.1224 8.54421 14.6 9.13332 14.6H14.8C15.3891 14.6 15.8667 14.1224 15.8667 13.5333C15.8667 12.9442 15.3891 12.4667 14.8 12.4667H9.13332Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8314 27.1715C3.71504 23.2783 5.96612 19.2173 9.85931 18.1009C13.7525 16.9846 17.8135 19.2356 18.9299 23.1288L19.1688 23.9619C20.2851 27.8551 18.0341 31.9162 14.1409 33.0325C10.2477 34.1489 6.18664 31.8978 5.07028 28.0046L4.8314 27.1715Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9765 24.017L18.7376 23.184C17.6517 19.3969 13.7015 17.2073 9.91444 18.2932C6.12742 19.3791 3.93774 23.3294 5.02365 27.1164L5.26254 27.9495C6.34845 31.7365 10.2987 33.9262 14.0857 32.8403C17.8728 31.7543 20.0624 27.8041 18.9765 24.017ZM9.85931 18.1009C5.96612 19.2173 3.71504 23.2783 4.8314 27.1715L5.07028 28.0046C6.18664 31.8978 10.2477 34.1489 14.1409 33.0325C18.0341 31.9162 20.2851 27.8551 19.1688 23.9619L18.9299 23.1288C17.8135 19.2356 13.7525 16.9846 9.85931 18.1009Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73328 16.1334H13.9999V18.2667H9.73328V16.1334Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7999 16.3334H9.93328V18.0667H13.7999V16.3334ZM9.73328 16.1334V18.2667H13.9999V16.1334H9.73328Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93323 16.1334H13.7999V18.8H9.93323V16.1334Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80005 10.5666C8.80005 8.81773 10.2178 7.39996 11.9667 7.39996C13.7156 7.39996 15.1334 8.81773 15.1334 10.5666V14.1C15.1334 15.8489 13.7156 17.2666 11.9667 17.2666C10.2178 17.2666 8.80005 15.8489 8.80005 14.1V10.5666Z",
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9334 14.1V10.5666C14.9334 8.92819 13.6052 7.59996 11.9667 7.59996C10.3283 7.59996 9.00005 8.92819 9.00005 10.5666V14.1C9.00005 15.7384 10.3283 17.0666 11.9667 17.0666C13.6052 17.0666 14.9334 15.7384 14.9334 14.1ZM11.9667 7.39996C10.2178 7.39996 8.80005 8.81773 8.80005 10.5666V14.1C8.80005 15.8489 10.2178 17.2666 11.9667 17.2666C13.7156 17.2666 15.1334 15.8489 15.1334 14.1V10.5666C15.1334 8.81773 13.7156 7.39996 11.9667 7.39996Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.2667H9.53333L9 12.5333V11.2667Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9333 11.2667H14.4L14.9333 12.5333V11.2667Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5243 18.7333C15.3932 19.771 13.8505 20.5899 11.9667 20.5899C10.0938 20.5899 8.55804 19.7804 8.41144 18.7513C5.90272 19.4698 4.06665 21.7806 4.06665 24.5201V29.0535H19.9333V24.5201C19.9333 21.7572 18.0658 19.4305 15.5243 18.7333Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4956 20.2278C13.8249 20.5797 12.9354 20.7899 11.9667 20.7899C11.0035 20.7899 10.1187 20.5821 9.44939 20.234C8.87053 19.9329 8.42614 19.511 8.2652 19.0053C5.94371 19.7631 4.26665 21.946 4.26665 24.5201V28.8535H19.7333V24.5201C19.7333 21.9236 18.027 19.7252 15.6742 18.9859C15.5196 19.4968 15.0759 19.9235 14.4956 20.2278ZM15.4822 18.9292C15.1948 19.8722 13.7302 20.5899 11.9667 20.5899C10.2139 20.5899 8.75642 19.8809 8.45651 18.9465C8.43596 18.8824 8.42084 18.8174 8.41144 18.7513C8.34656 18.7699 8.28213 18.7896 8.21817 18.8103C5.80898 19.5896 4.06665 21.8514 4.06665 24.5201V29.0535H19.9333V24.5201C19.9333 21.828 18.1603 19.55 15.7183 18.7901C15.6541 18.7701 15.5894 18.7512 15.5243 18.7333C15.5159 18.7996 15.5018 18.8649 15.4822 18.9292Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4895 9.71201C8.4895 8.88108 9.00328 8.13671 9.78019 7.84201L10.1085 7.71747C11.3272 7.25523 12.6729 7.25523 13.8915 7.71747L14.2199 7.84201C14.9968 8.13671 15.5106 8.88108 15.5106 9.71201V11.6H8.4895V9.71201Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3106 11.4V9.71201C15.3106 8.96417 14.8482 8.29424 14.1489 8.02901L13.8206 7.90447C12.6477 7.45956 11.3524 7.45956 10.1795 7.90447L9.85112 8.02901C9.1519 8.29424 8.6895 8.96417 8.6895 9.71201V11.4H15.3106ZM9.78019 7.84201C9.00328 8.13671 8.4895 8.88108 8.4895 9.71201V11.6H15.5106V9.71201C15.5106 8.88108 14.9968 8.13671 14.2199 7.84201L13.8915 7.71747C12.6729 7.25523 11.3272 7.25523 10.1085 7.71747L9.78019 7.84201Z",
    fill: "#111111"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric04);
export default __webpack_public_path__ + "static/media/Generic 04.699311b45a389015d21bda5f17a262e1.svg";
export { ForwardRef as ReactComponent };